import { useToast } from "@chakra-ui/react";
import { UseToastOptions } from "@chakra-ui/react/dist/types/toast/use-toast";

export const useStandardToast = () => {
  const toast = useToast();
  return (options?: UseToastOptions) => {
    toast({
      duration: 2000,
      isClosable: true,
      position: "top-right",
      ...(options || {}),
    });
  };
};
